import React from 'react';
import cn from 'classnames';
import { useEditorContext } from '../../Editor/Context';
import { useForceUpdate } from '../../../hooks/useForceUpdate';
import CharacterCount from '../items/CharacterCount';
import s from './AttachmentCaptionMenu.scss';
const AttachmentCaptionMenu = ()=>{
    const editor = useEditorContext();
    const forceUpdate = useForceUpdate();
    // Listen to editor as its not react so we need to react here
    editor === null || editor === void 0 ? void 0 : editor.on('transaction', ()=>{
        forceUpdate();
    });
    if (!editor) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'])
    }, /*#__PURE__*/ React.createElement(CharacterCount, {
        editor: editor
    }));
};
AttachmentCaptionMenu.displayName = 'AttachmentCaptionMenu';
export default AttachmentCaptionMenu;

//# sourceMappingURL=AttachmentCaptionMenu.js.map